import { vOnClickOutside } from '@vueuse/components'
export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.directive('on-click-outside', vOnClickOutside)
})
